import { Label as LabelPrimitive } from "radix-ui";
// eslint-disable-next-line import/no-namespace -- shadcn vendor file
import * as React from "react";

import { cn } from "../../lib/utils";

function Label({ className, ...properties }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(
        "flex select-none items-center gap-2 text-xs font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        className
      )}
      {...properties}
    />
  );
}

export { Label };
